import { newSettingsState, SettingsState } from './slices/settings';
import { AccountState, newAccountState } from './slices/account';
import { newRegisterState, RegisterState } from './slices/register';
import { CredentialsState, newCredentialsState } from './slices/credentials';
import { LoginState, newLoginState } from './slices/login';
import { DebugState, newDebugState } from './slices/debug';


export type RootState = {
  object: "RootState";
  version: number;
  debug: DebugState;
  credentials: CredentialsState;
  settings: SettingsState;
  account: AccountState;
  register: RegisterState;
  login: LoginState;
};

export function createRootState(): RootState {
  return {
    object: "RootState",
    version: 1,
    debug: newDebugState(),
    settings: newSettingsState(),
    account: newAccountState(),
    credentials: newCredentialsState(),
    register: newRegisterState(),
    login: newLoginState(),
  }
}

/** Select a copy of the root state. */
export const selectRootState = () => (state: RootState) => {
  return state;
}
